import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Basic from './basic';
import Design from './design';
import CustomForm from './form';
import { sourceData } from './design/examples';
import { getWorkFlow, workFlowSave, selectApi as _selectApi, workUpdateSave } from 'api/flow';
import { verification } from './design/rules';
import { basicComponents, baseInfo, initForm } from './form/enum';
import '../style/index.scss';
export default {
  components: {
    Basic: Basic,
    Design: Design,
    CustomForm: CustomForm
  },
  data: function data() {
    return {
      loading: false,
      // 当前步骤条
      active: 0,
      // 审批流下拉选项
      selectData: {
        audit: [],
        group: [],
        status: []
      },
      // 审批流出实话数据
      flowData: {
        form: initForm(),
        tableId: 1,
        workFlowVersionId: '',
        workFlowDef: baseInfo(),
        nodeConfig: JSON.parse(JSON.stringify(sourceData)),
        // 审批流信息
        directorMaxLevel: 10,
        // 审核人 部门负责人筛选项
        flowPermission: []
      }
    };
  },
  computed: {
    // 旧的审批流区分表单配置
    asyncComponent: function asyncComponent() {
      var arr = _toConsumableArray(basicComponents);
      var type = this.flowData.workFlowDef.type;
      if (type !== 2) arr.splice(1, 1);
      return arr;
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.getFlow();
      this.selectApi();
      // 折叠MENU菜单
      this.$nextTick(function () {
        _this.$store.dispatch('app/closeSideBar', {
          withoutAnimation: false
        });
      });
    },
    // 返回上一步
    goBack: function goBack() {
      var _this2 = this;
      this.$confirm(this.$t('280164ef'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this2.$router.push({
          path: '/approval/config'
        });
      });
    },
    // 步骤条切换
    // @param { bool } isLast
    // 上一步或下一步
    handleChangeStep: function handleChangeStep(isLast) {
      if (!isLast) {
        var state = this.$refs.stepDom.doSubmit ? this.$refs.stepDom.doSubmit() : true;
        if (!state) {
          this.$message.error(this.$t('i18n.4fdf2bec1aeb43c7bddb15a61c8ad13f'));
          return false;
        }
      }
      this.active = isLast ? this.active - 1 : this.active + 1;
    },
    // 获取下拉框数据
    selectApi: function selectApi() {
      var _this3 = this;
      _selectApi().then(function (res) {
        if (res && res.code === 1) _this3.selectData = res.data;
      });
    },
    // 获取数据
    getFlow: function getFlow() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var query, params, base, _yield$getWorkFlow, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.loading = true;
              query = _this4.$route.query; // 无id为新增，不用获取详情
              if (query.fid) {
                _context.next = 10;
                break;
              }
              _this4.loading = false;
              params = _this4.$route.query.params;
              if (params) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", _this4.$router.go(-1));
            case 7:
              base = JSON.parse(params);
              _this4.flowData.workFlowDef = _objectSpread(_objectSpread({}, baseInfo()), base);
              return _context.abrupt("return", false);
            case 10:
              _context.next = 12;
              return getWorkFlow({
                id: window.atob(query.fid)
              });
            case 12:
              _yield$getWorkFlow = _context.sent;
              data = _yield$getWorkFlow.data;
              _this4.flowData = data.flow_request || data;
              _this4.loading = false;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 发布
    handlerRelease: function handlerRelease() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, msg, res, status, _msg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.$refs.stepDom.save && _this5.$refs.stepDom.save();
              // 审批流校验
              result = verification(_this5.flowData.nodeConfig);
              if (result) {
                _context2.next = 5;
                break;
              }
              _this5.$message({
                message: _this5.$t('work_rule_63'),
                type: 'warning'
              });
              return _context2.abrupt("return");
            case 5:
              msg = {
                workflow_request: JSON.stringify(_this5.flowData)
              };
              if (!_this5.$route.query.fid) {
                _context2.next = 14;
                break;
              }
              msg.id = window.atob(_this5.$route.query.fid);
              _context2.next = 10;
              return workUpdateSave(msg);
            case 10:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this5.$message({
                  message: _this5.$t('886'),
                  type: 'success'
                });
              }
              _context2.next = 19;
              break;
            case 14:
              msg.audit_type = _this5.flowData.workFlowDef.audit_type;
              _context2.next = 17;
              return workFlowSave(msg);
            case 17:
              res = _context2.sent;
              if (res && res.code === 1) {
                status = res.data.status;
                _msg = _this5.$t('work_rule_64');
                if (status === 1) {
                  _msg = "".concat(_this5.$t('work_rule_65'), "<span style=\"color: #1592ff\">").concat(_this5.$t('work_rule_66'), "</span>\uFF0C").concat(_this5.$t('work_rule_67'));
                }
                _this5.$message({
                  dangerouslyUseHTMLString: true,
                  message: _msg,
                  type: status === 1 ? 'warning' : 'success'
                });
              }
            case 19:
              if (res && res.code === 1) {
                _this5.$router.push('/approval/config');
              }
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};